import { TextInput } from "../../text-input";
import { forwardRef, useCallback } from "react";
import { CrossButton } from "../../button";
import { Keys, isNil, isNilOrEmpty, isUndefined, mergeProps, useChainedEventCallback, useControllableState, useEventCallback, useMergedRefs } from "../../shared";
import { MagnifierIcon } from "../../icons";
import { useInputGroupTextInputProps } from "../../input-group";
import { wrappedInputPropsAdapter } from "../../input";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "input";
export function InnerSearchInput(props) {
  const [inputGroupProps] = useInputGroupTextInputProps();
  const {
    as = DefaultElement,
    defaultValue,
    forwardedRef,
    icon,
    onChange,
    onKeyDown,
    onValueChange,
    value,
    wrapperProps,
    ...rest
  } = mergeProps(props, wrappedInputPropsAdapter(inputGroupProps));
  const [inputValue, setValue] = useControllableState(value, defaultValue, "");
  const inputRef = useMergedRefs(forwardedRef);
  const updateValue = useCallback((event, newValue) => {
    setValue(newValue);

    if (!isNil(onValueChange)) {
      onValueChange(event, newValue);
    }
  }, [onValueChange, setValue]);
  const clear = useCallback(event => {
    updateValue(event, "");
  }, [updateValue]);
  const handleChange = useChainedEventCallback(onChange, event => {
    updateValue(event, event.target.value);
  });
  const handleKeyDown = useEventCallback(event => {
    if (!isNil(onKeyDown)) {
      onKeyDown(event);
    } // Can't change for now otherwise Autocomplete will break.


    if (!event.isPropagationStopped()) {
      if (event.key === Keys.esc) {
        event.preventDefault();
        clear(event);
      }
    }
  });
  const handleClear = useEventCallback(event => {
    clear(event);
    inputRef.current.focus();
  });

  const clearButtonMarkup = !isNilOrEmpty(inputValue) && /*#__PURE__*/_jsx(CrossButton, {
    "aria-label": "Clear value",
    className: "o-ui-search-input-clear-button",
    condensed: true,
    onClick: handleClear,
    size: "xs",
    title: "Clear value"
  });

  return /*#__PURE__*/_jsx(TextInput, { ...mergeProps(rest, {
      as,
      autoComplete: "off",
      autoCorrect: "off",
      button: clearButtonMarkup || undefined,
      icon: isUndefined(icon) ? /*#__PURE__*/_jsx(MagnifierIcon, {}) : icon,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      ref: inputRef,
      spellCheck: "false",
      type: "search",
      value: inputValue,
      wrapperProps: mergeProps(wrapperProps !== null && wrapperProps !== void 0 ? wrapperProps : {}, {
        className: "o-ui-search-input"
      })
    })
  });
}
InnerSearchInput.defaultElement = DefaultElement;
export const SearchInput = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerSearchInput, { ...props,
  forwardedRef: ref
}));